<template>
  <div class="fav-page page">

      <div class="product-header">
          <h1><i class="icon icon-favourite icon-favourite-full"></i>Favoriten</h1>
      </div>
    
<!--
      <div class="column" v-for="(product, i) in user.fav" :key="i" :sync="user.fav">
        <div class="favourite-product-link">
           <router-link  :to="{ name: 'ProductPage', params: { articlenumber: product.articlenumber } }">
                <div class="prod-img-container">
                  <img :src=" config.appUrl + product.attributes.images[0].sizes.small">
                </div>
            <div class="p-name p-detail">{{product.articlenumber}} </div>
            </router-link>
            <div class="p-remove p-detail"><i class="icon icon-remove" v-on:click="removeFromFavorites(i)"></i></div>
        </div>
      </div>
-->

      <div class="products">
          <div class="product-list">
              <div class="product" v-for="(product, i) in user.fav" :key="i" v-if="product.attributes.images.length > 0">
                <a class="fav-preview" v-on:click="love_it_not_anymore(product)"><i :class=" 'icon icon-favourite ' + checkFav(product.articlenumber) "></i><span>Zu Favoriten</span></a>
                <div class="product-image"><img :src=" config.appUrl + product.attributes.images[0].sizes.small" loading="lazy"></div>
                <div class="overlay-artno">
                    <router-link :to="{ name: 'ProductPage', params: { articlenumber: product.articlenumber }}">{{product.articlenumber}}</router-link>
                </div>
                <div class="overlay-details">
                    <router-link :to="{ name: 'ProductPage', params: { articlenumber: product.articlenumber }}">ansehen</router-link>
                </div>
                
              </div>
          </div>
      </div>

  </div>
</template>
<script>

import config from '../_config/config';

export default {
  
    name: 'FavoritesPage',
/*
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      }
    },
*/
    data: function(){
      return {
         config
         }
    },
    created: function(){
        this.config = config
    },
    mounted: function(){
      console.log( this.user );
    },
    computed: {    
        user () {
            return this.$store.state.authentication.user;
        },
        
        products () {
          return this.$store.state.products.all
        },
        
        favProducts(){
          //return this.user.fav
        },
        
    },
    methods: {


      checkFav( articlenumber ){
         if(this.user)
         return ( this.user.fav.filter( (favItem) => { return favItem.articlenumber == articlenumber }).length > 0 ? 'icon-favourite-full':'')
      },



      love_it_not_anymore( product ){
        
        if(!this.user) {
              this.$emit('loginRequired')
              return
              }
        
        
          //var i = this.user.fav.indexOf( product.id )
//           var i = this.$store.state.authentication.user.fav.findIndex(x => x.articlenumber === product.articlenumber) //indexOf( this.articlenumber )
//           this.$store.state.authentication.user.fav.splice(i,1);
        
//         this.updateFavOnServer()

      },

       updateFavOnServer(){
          const fav = this.user.fav;
          const { dispatch } = this.$store;
          dispatch('fav/update', { fav });
       },      
      
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           //console.log(img.width);
           return true //img.width > 0;
        },
/*
      removeFromFavorites(i) {
       this.user.fav.splice(i,1)
       this.updateFavOnServer()
     },
     
     updateFavOnServer(){
        const fav = this.user.fav;
        const { dispatch } = this.$store;
        dispatch('fav/update', { fav });
        // use: this.updateFavOnServer()
     },
*/
     
 
    }
}
</script>
<style>

  .fav-page { position: relative; padding: 9rem 0 9.88888em 0; height: 100%; min-height: 100vh; }

  .product-header { padding: 0.93333em 0.93333em 0.7333em; }

  .fav-page .product-list { display: flex; flex-wrap: wrap; outline: 0 solid green; margin-right: 0px; padding: 0 0.733333em; }
  .fav-page .product-list .product { flex: 1 1 33.333%; max-width: 33.3333%; position: relative; z-index: 1; padding: 0.222em; margin: 0;  transform: scale(1.001); transition:all 0.3s ease; box-shadow: 0; }
  .fav-page .product-list .product img { display: block; width: 100%; max-width: 100%; margin: 0; padding: 0; }

  
  @media screen and ( min-width: 40em) {
    .fav-page .products { margin-right: 0.43333em /* 19rem */; padding-top: 0rem;  }
    .fav-page .product-list { padding: 0 0.733333em; }    
    .fav-page .product-list .product { flex: 0 1 25%; }
    .fav-page .product-filter h2 { }
  }
  @media screen and ( min-width: 64.06333em) {      
    .fav-page .product-list .product { flex: 0 1 16.666%; }
  }
  
   .fav-page .overlay-artno { position: absolute; top: auto; bottom: -1em; left: 0; right: 0;  opacity: 0; transform: translate(0,30px); transition: transform 0.3s, opacity 0.3s ease;  }
   .fav-page .overlay-artno a { 
    display: block; background: rgba(0,0,0,0.7)  ;
    border-radius: 0; padding: 0.22222em 0.43333em; text-decoration: none; font-size: 0.8rem; text-align: center; 
  }

  .fav-page .overlay-details { position: absolute; top: 50%; margin-top: -1.20rem; right: 0; left: 0; text-align: center; }
  .fav-page .overlay-details a { display: block; padding:0.0511em 0.633333em; margin: 0 auto; 
    background: rgba(0,0,0,0.7) url(/img/icons-white/search.svg) center center no-repeat; background-size: 1.5rem; text-indent: -9999px; 
    width: 2.5rem; height: 2.3rem;
    border-radius: 3px; 
    text-decoration: none; 
    transform: scale(0.5);
    opacity: 0;
    transition: transform 0.3s, opacity 0.3s ease; 
    font-size: 0.9rem }



  .fav-page .product-list .fav-preview { position: absolute; top: 0.3333rem; right: 0.3333rem; cursor: pointer;  } 
  .fav-page .product-list .fav-preview { transform: scale(0.9); transition: transform 0.3s; }
  .fav-page .product-list .fav-preview i { transform: scale(0.7); }
  .fav-page .product-list .fav-preview:hover i { transform: scale(0.9);  }
  .fav-page .product-list .fav-preview span { display: none; }


/*   .fav-page .product-list .fav-preview { display: none; } */


  .fav-page .product-list .product:hover { z-index: 500; }

  .fav-page .product-list .product:hover .overlay-artno { transform: translate(0,0);  opacity: 1; }
  .fav-page .product-list .product:hover .overlay-details a { transform: scale(1); opacity: 1; }
  .fav-page .product-list .product:hover { transform: scale(1.1); background: rgba(0,0,0,0.6); box-shadow: 0 0 10px rgba(0,0,0,0.6);  }
  .fav-page .product-list .product:hover img { }

/*
  .favourite-product-link { display: flex; align-items: center; width: 100%; flex-wrap: wrap;  }
  .favourite-product-link a { width: 50%; max-width: 20em; display: flex; align-items: center; text-decoration: none !important; }
  .favourite-product-link:before { display: none; }
  .favourite-product-link .prod-img-container { width: 6em; }
  .favourite-product-link .p-detail { padding: 0.9333333em;  color: #fff; }
  .favourite-product-link .p-detail.p-name { font-weight: bold; width: 13em; min-width: 10em;  }
  .favourite-product-link .p-detail.p-vpe {  width: 10em; min-width: 10em;  }
  .favourite-product-link .p-detail.p-name span { font-weight: normal; display: block;  }
  .favourite-product-link .p-detail.p-count { font-weight: bold; color: #dc1200; display: flex;  }
  .favourite-product-link .p-detail.p-notes { width: 30%; min-width: 18em; }
  .favourite-product-link .p-detail.p-notes textarea { width: 100%; border: 1px solid #ddd; border-radius: 3px; padding: 0.43333333em; outline: 0 !important; transition: border-color 0.2s ease-in-out; }
  .favourite-product-link .p-detail.p-notes textarea:focus { border: 1px solid #fff; }
  .favourite-product-link input[type="number"] { width: 3em; text-align: right; margin: 0 0.2333333em }
  .favourite-product-link .p-detail.p-remove { width: 3em; }
*/
  
</style>